// extracted by mini-css-extract-plugin
export default {"table-container":"Table_table-container__c0sMz"};